import React from "react";
import { Edit, SimpleForm, TextInput, NumberInput, BooleanInput, required } from "react-admin";
import { useClub } from "../club/ClubContext";
import { Box, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

export function PenaltyTypeEdit() {
  const { clubId } = useClub();
  const navigate = useNavigate();
  return (
    <Box p={2}>
      <Box mb={2}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => navigate("/penalty-types")}>
          Zurück zum Katalog
        </Button>
      </Box>
      <Edit title="Strafentyp bearbeiten" transform={(d: any) => ({ ...d, club_id: d.club_id ?? clubId })}>
        <SimpleForm>
          <TextInput source="name" label="Name" validate={required()} fullWidth />
          <TextInput source="description" label="Beschreibung (optional)" fullWidth multiline rows={2} />
          <NumberInput
            source="amount"
            label="Betrag (€)"
            validate={required()}
            min={0}
            step={0.5}
            fullWidth
            helperText="Fester Betrag. Wird verwendet, wenn kein Min/Max/Schritt gesetzt ist."
          />
          <NumberInput source="min_value" label="Min.-Betrag (€, optional)" min={0} step={0.5} />
          <NumberInput source="max_value" label="Max.-Betrag (€, optional)" min={0} step={0.5} />
          <NumberInput
            source="delta"
            label="Schrittweite (€, optional)"
            min={0.01}
            step={0.5}
            helperText="Wenn Min/Max/Schritt gesetzt sind, kann der Betrag beim Vergeben per Schieberegler gewählt werden (z. B. je Minute zu spät = 1 €)."
            fullWidth
          />
          <BooleanInput source="active" label="Aktiv" />
        </SimpleForm>
      </Edit>
    </Box>
  );
}
